import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { trackEvent, EVENTS } from '../../lib/analyticsV2';
import { ownerVerifiedContent } from './contentConfig';

const faqs = [
  {
    id: "o-que-e-diagnostico",
    question: "O que é o diagnóstico?",
    answer: "É uma etapa inicial para organizar objetivo, prazo, fluxo de caixa, liquidez, custos e riscos. Ele não garante contemplação, crédito, rentabilidade ou aprovação."
  },
  {
    id: "consorcio-e-investimento",
    question: "Consórcio é investimento?",
    answer: "Não se deve tratar consórcio como aplicação com rendimento garantido. Ele é uma modalidade contratual de aquisição/autofinanciamento, sujeita a regras, custos e incerteza de contemplação. A adequação depende do objetivo, prazo e capacidade de pagamento."
  },
  {
    id: "sem-juros-sem-custos",
    question: "“Sem juros” quer dizer que não há custos?",
    answer: "Não. A expressão não elimina taxa de administração nem outros custos que possam estar no contrato. Eles devem ser apresentados antes da decisão, com memória de cálculo e identificação de quem os recebe."
  },
  {
    id: "contemplacao-garantida",
    question: "A contemplação tem data garantida?",
    answer: "Não deve ser prometida. Ela depende das regras do grupo, sorteio, lance e condições contratuais. Qualquer estratégia deve explicar as hipóteses e o que acontece se a contemplação demorar."
  },
  {
    id: "aluguel-paga-parcela",
    question: "O aluguel paga a parcela?",
    answer: "Não há garantia. É necessário considerar vacância, inadimplência, impostos, condomínio, manutenção, seguros, reajustes, custos de aquisição e variações de preço e aluguel."
  },
  {
    id: "como-remunerados",
    question: "Como vocês são remunerados?",
    answer: ownerVerifiedContent.compensationModel
  },
  {
    id: "posso-cancelar",
    question: "Posso sair ou cancelar?",
    answer: "As condições dependem do contrato, do grupo e do momento da desistência. O visitante deve receber o regulamento e os custos aplicáveis antes de contratar."
  },
  {
    id: "quais-documentos",
    question: "Quais documentos preciso enviar?",
    answer: "No primeiro diagnóstico, nenhum documento sensível é necessário. Se uma etapa posterior exigir documentos, o canal, finalidade, retenção e medidas de segurança serão informados antes do envio."
  },
  {
    id: "como-dados-usados",
    question: "Como meus dados serão usados?",
    answer: "[CONFIRMAR: inserir finalidade, base legal, prazo de retenção, operadores, direitos do titular e canal de contato conforme política de privacidade publicada]"
  }
];

const FaqV2 = () => {
  const [openId, setOpenId] = useState(null);

  const toggleFaq = (id) => {
    const isOpening = openId !== id;
    setOpenId(isOpening ? id : null);
    
    if (isOpening) {
      trackEvent(EVENTS.FAQ_EXPAND, { faq_id: id });
    }
  };

  return (
    <section id="faq" className="py-16 md:py-24 bg-muted/30">
      <div className="container px-4 md:px-6 mx-auto max-w-3xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold tracking-tight md:text-4xl">Perguntas Frequentes</h2>
        </div>

        <div className="space-y-4">
          {faqs.map((faq) => (
            <div key={faq.id} className="border rounded-lg bg-card">
              <button
                onClick={() => toggleFaq(faq.id)}
                className="flex w-full items-center justify-between p-4 text-left font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
                aria-expanded={openId === faq.id}
              >
                {faq.question}
                {openId === faq.id ? (
                  <ChevronUp className="h-5 w-5 text-muted-foreground shrink-0" />
                ) : (
                  <ChevronDown className="h-5 w-5 text-muted-foreground shrink-0" />
                )}
              </button>
              {openId === faq.id && (
                <div className="px-4 pb-4 text-muted-foreground text-sm leading-relaxed">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FaqV2;
